import styled from 'styled-components';

export const Table = styled.table`
`;

export const Thead = styled.thead`
    tr{
        border: none!important;
    }
`;

export const Tr = styled.tr`
   ${({selectable}) =>
     selectable &&
     `
        cursor: pointer;
        &:hover {
            background-color: lightgrey;
        }
    `}
    border-top: 1px solid lightgrey;
    &:first-child{
        border-top: 2px solid lightgrey;
    }
`;

export const Th = styled.th`
    width: ${props => props.customWidth};
    color: black;
    font-weight: normal;
    padding: 5px;
    border-top:0;
    text-align:left;

`;

export const Td = styled.td`
    padding: 10px;
    color: black;
`;
//${''/* max-height: ${props => props.showMore ? '50px' : 'none'};
//cursor: ${props => props.showMore ? '50px' : 'none'}; */}



// WEBPACK FOOTER //
// ./src/components/table/Table.js